// PIN profilu dziecka po stronie aplikacji (patch-34): kształt PIN-u i lokalny skrót, dzięki któremu dziecko wejdzie do swojego profilu także bez internetu.
// Prawdziwa kontrola PIN-u jest na serwerze (server/profiles.ts: skrót z solą, blokada po 5 błędach w 15 minut). To jest tylko zapas na brak sieci:
// po udanym sprawdzeniu przeglądarka zapamiętuje skrót PIN-u i bez internetu porównuje z nim. PIN to zamek „na dziecko”, nie tajemnica bankowa.

export const PIN_LENGTH = 4;

/** Dokładnie cztery cyfry. */
export const isPin = (value: string): boolean => /^[0-9]{4}$/.test(value);

/** SHA-256 z identyfikatorem profilu (ten sam PIN w dwóch profilach daje dwa skróty); null, gdy przeglądarka nie ma `crypto.subtle`. */
export async function localPinDigest(profileId: string, pin: string): Promise<string | null> {
  try {
    const subtle = globalThis.crypto?.subtle;
    if (!subtle) return null;
    const buf = await subtle.digest('SHA-256', new TextEncoder().encode(`naative-pin:${profileId}:${pin}`));
    return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return null;
  }
}
